<template>
    <div v-if="Object.keys(artistInfo).length" class="artist-profile-container">
        <div id="preloader" v-show="load" class="preloader"></div>
        <div class="info-wrapper">
            <div :style="backgroundImage" class="artist-profile-image"></div>
            <div class="info-wrapper-right-col">
                <p class="artist-name">
                    {{ artistInfo.band_name }}
                </p>
                <div class="artist-location">
                    {{ artistCityState(artistInfo.city_state_address) }}
                </div>
                <p class="artist-keywords">
                    {{ artistKeywords }}
                </p>
                <p
                    v-if="upfluenceData !== null && upfluenceData !== '0'"
                    class="artist-social-reach"
                >
                    {{ formatSummedValue(upfluenceData) }} Social Reach
                </p>
                <div class="artist-socials">
                    <div v-for="social in socialInfo" :key="social.link" class="social">
                        <a :href="socialLink(social)" target="_blank">
                            <img :src="URLS.icons[social.type]" :alt="social.type" />
                            <div class="followers-count">
                                {{ calculateNumFollowers(social) }}
                            </div>
                        </a>
                    </div>
                </div>
                <p class="artist-short-bio">
                    {{ artistInfo.short_biography }}
                </p>
                <div class="page-owner-title">This Page Owned by</div>
                <div class="page-owner-container">
                    <div :style="pageOwnerImage" class="page-owner-image"></div>
                    <div class="page-owner-name">
                        {{ artistInfo.booker_user_name }}
                    </div>
                </div>
                <div v-if="currentUser" class="artist-actions">
                    <button @click="handleEditArtist" class="edit-page-btn">
                        Edit this page
                    </button>
                </div>
                <div v-else class="artist-actions">
                    <div class="artist-actions-left-container">
                        <!--<button
                            :disabled="followingArtist === 'Following' || !fetchedContacts"
                            @click="followBtnClick"
                            class="follow-artist-btn"
                        >
                            {{ followingArtist }}
                        </button>-->
                        <button @click="messageArtist" class="message-artist-btn">
                            Message
                        </button>
                    </div>
                    <button @click="handleBookArtist" class="book-artist-btn">Book</button>
                </div>
            </div>
        </div>
        <div v-if="showProfileMedia" class="media-wrapper">
            <div class="section-title media">Media</div>
            <div class="organizer">
                <MediaOrganizer
                    :user-id="artistInfo.artist_id"
                    :videos="artistVideos"
                    :images="mediaCarousel"
                    :audios.sync="musicInfo"
                    :editable="false"
                    :isRightAligned="true"
                />
            </div>
        </div>
        <div v-if="hasFanStats" class="fan-stats-wrapper">
            <div class="section-title">Fan Stats</div>
            <div class="fan-stats-columns">
                <div class="fan-stats-column cities">
                    Top 5 cities
                    <div class="chart-container">
                        <div class="legend-container">
                            <div v-for="(city, index) in topCities.labels" :key="city">
                                <div
                                    :style="{
                                        color: citiesDonutChartOptions.colors[index]
                                    }"
                                    class="legend"
                                >
                                    <div class="city-name">{{ city }}</div>
                                    <div class="city-percentage">
                                        {{ topCities.series[index] }} %
                                    </div>
                                </div>
                            </div>
                        </div>
                        <apexchart
                            width="200"
                            type="donut"
                            :options="citiesDonutChartOptions"
                            :labels="topCities.labels"
                            :series="topCities.series"
                        ></apexchart>
                    </div>
                </div>
                <div class="fan-stats-column age">
                    Age
                    <apexchart
                        width="350"
                        type="bar"
                        :options="ageChartOptions"
                        :series="ageSeries"
                    ></apexchart>
                </div>
                <div class="fan-stats-column gender">
                    Gender
                    <div class="chart-container">
                        <div class="legend-container">
                            <div v-for="(gender, index) in gender.labels" :key="gender">
                                <div
                                    :style="{
                                        color: citiesDonutChartOptions.colors[index]
                                    }"
                                    class="legend"
                                >
                                    <div class="city-name">{{ gender }}</div>
                                    <div class="city-percentage">
                                        {{
                                            gender === 'Male'
                                                ? fanStats.gender_stats.male
                                                : fanStats.gender_stats.female
                                        }}
                                        %
                                    </div>
                                </div>
                            </div>
                        </div>
                        <apexchart
                            width="200"
                            type="donut"
                            :options="genderDonutChartOptions"
                            :labels="gender.labels"
                            :series="gender.series"
                        ></apexchart>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="upcomingShows.length" class="events-wrapper">
            <div class="section-title">Upcoming Events</div>
            <div v-if="!screen.isMobile.value" class="event-cards-wrapper">
                <event-cards
                    :eventsInfo="upcomingShows"
                    :eventClickable="true"
                    :renderShortDate="true"
                    :profile="true"
                    :styles="eventCardStyles"
                    @event-image-clicked="() => {}"
                    @event-date-clicked="() => {}"
                    @event-title-clicked="() => {}"
                >
                    <template #date-extra="{ event }">
                        <p class="event-time">Doors at {{ eventTime(event) }}</p>
                        <p v-if="event.cover_cost" class="cover-charge">
                            {{ `$${event.cover_cost} Cover` }}
                        </p>
                        <p class="event-age">
                            {{ `${event.min_age ? event.min_age + '+' : 'All Ages'}` }}
                        </p>
                    </template>
                    <template #title-extra="{ event }">
                        <p class="title-extra">at {{ event.venue.venue_name }}</p>
                    </template>
                    <template #info-extra="{ event }">
                        <div v-if="event.array_keywords.length" class="keyword-vibes">
                            <span class="vibe">Vibe: </span>
                            <span class="vibe">{{ eventVibes(event) }}</span>
                        </div>
                        <div
                            v-if="event.bookedArtists.length"
                            class="featured-artists-wrapper"
                        >
                            <p class="featured-label">Featuring:</p>
                            <div
                                v-for="(artist, indx) in event.bookedArtists"
                                :key="indx"
                                class="featured-artist"
                            >
                                <img :src="artist.avatar" alt="artist-avatar" />
                                <p class="featured-artist-name">{{ artist.band_name }}</p>
                            </div>
                        </div>
                    </template>
                </event-cards>
            </div>
            <div v-else class="event-card-wrapper">
                <MobileEventCards
                    :eventsInfo="upcomingShows"
                    :eventClickable="true"
                    :renderShortDate="true"
                />
            </div>
        </div>
    </div>
</template>
<script>
    import { api } from '@/helpers/api'
    import axios from 'axios'
    import { notification } from '@/helpers/notification'
    import EventCards from '@/components/ui/cards/EventCards.vue'
    import MobileEventCards from '@/components/ui/cards/MobileEventCards.vue'
    import useCheckScreen from '@/composables/useCheckScreen.js'
    import { useAuth } from '@/composables/auth/useAuth'
    import MediaOrganizer from '../../../artist-direct-booking/steps/parts/MediaOrganizer'
    import VueApexCharts from 'vue-apexcharts'

    const URLS = {
        xhr: {
            fetch: {
                checkAuth: '/api/check-authorization',
                user: '/api/profile/v1/settings/user',
                media: '/api/profile/v1/user-profile/artist-medias',
                unclaimedArtistMedia: '/api/profile/v1/user-profile/unclaimed-artist-medias',
                artist: '/api/profile/v1/user-profile/artist-info',
                unclaimedArtist: '/api/profile/v1/user-profile/unclaimed-artist-info',
                social: '/api/profile/v1/user-profile/artist-social-links',
                music: '/api/profile/audios',
                facility: '/api/profile/v1/info/artist/facility-settings',
                newEvents: '/api/events/new-and-proceed-list-guest',
                advancedEvents: '/api/events/advanced-list-guest',
                venueContacts: '/api/profile/contacts/venue/list',
                artistStats: '/api/profile/artist-stats/'
            },
            mutate: {
                addArtistContact: '/api/profile/contacts/user/artist'
            }
        },
        icons: {
            Instagram: '/images/icons/instagram-grey.svg',
            Facebook: '/images/icons/facebook-grey.svg',
            Tiktok: '/images/icons/tiktok-grey.svg',
            Youtube: '/images/icons/youtube-grey.svg',
            Spotify: '/images/icons/spotify-grey.svg',
            Mixcloud: '/images/icons/mix-grey.svg',
            Soundcloud: '/images/icons/soundcloud-grey.svg',
            web_site: '/images/icons/web-grey.svg',
            location: '/images/icons/location.svg',
            play: '/images/icons/video-play.svg'
        },
        redirect: {
            booking: '/booking-manager',
            createVenueUser: '/register',
            createVenueProfile: '/venues/create-new-profile',
            edit: ['/artists', 'edit'],
            marketingPlan: '/for-artists#plans'
        }
    }
    export default {
        name: 'ArtistProfile',
        components: {
            EventCards,
            MobileEventCards,
            MediaOrganizer,
            apexchart: VueApexCharts
        },
        props: {
            id: {
                required: true,
                type: Number,
                validator: (v) => v >= 0
            },
            artist: {
                required: true,
                type: Number,
                validator: (v) => v >= 0
            },
            claimed: {
                required: true,
                type: Boolean
            },
            upfluenceData: {
                type: String,
                required: false,
                validator(val) {
                    try {
                        return !!(JSON.parse(val) && val)
                    } catch (e) {
                        return false
                    }
                }
            }
        },
        data: () => ({
            authed: false,
            load: false,
            videoPlaying: false,
            fetchedContacts: false,
            userInfo: {},
            artistInfo: {},
            socialInfo: [],
            mediaInfo: [],
            followerStats: {},
            fanStats: {},
            topCities: {},
            gender: {},
            ageSeries: {},
            citiesDonutChartOptions: {},
            genderDonutChartOptions: {},
            ageChartOptions: {},
            musicInfo: [],
            eventsInfo: [],
            contacts: [],
            filteredEvents: [],
            upcomingShows: [],
            artistVideos: [],
            mediaCarousel: [],
            showBioPartTwo: false,
            eventCardStyles: {
                card: {
                    'min-height': '273px',
                    'max-width': '727px',
                    width: '100%',
                    cursor: 'pointer'
                },
                date: {
                    color: '#acacac',
                    'font-size': '26px'
                },
                title: {
                    color: '#acacac',
                    'font-size': '20px',
                    'font-weight': '650'
                },
                image: {
                    width: '182px'
                }
            },
            musicPlayerStyles: {
                player: {
                    'min-width': '280px',
                    'max-width': '727px',
                    width: '100%'
                }
            },
            carouselOptions: {
                index: 0,
                style: {
                    currentMedia: {
                        width: 406,
                        height: 406
                    },

                    otherMedia: {
                        width: 365,
                        height: 365
                    },

                    actionBtns: {
                        Xoffset: 280,
                        Yoffset: 235,
                        twoMediaXoffSet: 100
                    }
                },
                mobileStyle: {
                    currentMedia: {
                        width: 260,
                        height: 260
                    },

                    otherMedia: {
                        width: 220,
                        height: 220
                    },

                    actionBtns: {
                        Xoffset: 200,
                        Yoffset: 180,
                        twoMediaXoffSet: 100
                    }
                }
            }
        }),
        computed: {
            URLS: () => URLS,
            backgroundImage: (self) => {
                if (
                    self.artistInfo.avatar &&
                    !self.artistInfo.avatar.includes('/images/global/default.png')
                ) {
                    const avatar = encodeURI(self.artistInfo.avatar)
                    return {
                        'background-image': `url('${avatar}')`
                    }
                }

                return {}
            },
            pageOwnerImage: (self) => {
                if (
                    self.userInfo.avatar &&
                    !self.userInfo.avatar.includes('/images/global/default.png')
                ) {
                    const avatar = self.artistInfo.booker_user_avatar
                    const baseUrl = window.location.origin
                    const userImage = baseUrl + '/' + avatar
                    return {
                        'background-image': `url('${userImage}')`
                    }
                }
                return {}
            },
            artistCityState: () => (address) => {
                let addressArr = address.replace(', USA', '').split(',').reverse()
                let city = addressArr[1]
                let state = addressArr[0].trim().split(' ')[0]

                return `${city}, ${state}`
            },
            artistKeywords: (self) =>
                self.artistInfo.keyword ? self.artistInfo.keyword.split(',').join(', ') : '',
            longBio: (self) =>
                self.artistInfo.long_biography && self.artistInfo.long_biography.length > 370,
            bioPartOne: (self) =>
                self.artistInfo.long_biography
                    ? self.artistInfo.long_biography.slice(0, 371)
                    : '',
            bioPartTwo: (self) =>
                self.artistInfo.long_biography
                    ? self.artistInfo.long_biography.slice(371)
                    : '',
            currentUser: (self) => {
                if (self.authed) {
                    // Find the artist object with the matching slug from artistPages
                    return self.userInfo.artistPages.some(
                        (artist) => artist.slug === self.currentSlug
                    )
                }
                return false
            },
            currentSlug: () => {
                let url = window.location.href

                if (url[url.length - 1] === '/') {
                    url = url.slice(0, -1)
                }
                return url.split('/').pop()
            },
            // showUnlockable: (self) => {
            //     if (self.currentUser && !self.artistInfo.subscription) {
            //         return true
            //     }
            //
            //     return false
            // },
            showProfileMedia: (self) =>
                self.musicInfo.length || self.artistVideos.length || self.mediaCarousel.length,
            eventTime: () => (event) => {
                if (event.start_time) return event.start_time.split(' - ')[0]
                return 'N/A'
            },
            eventVibes: () => (event) => {
                if (event.array_keywords.length) {
                    return event.array_keywords.join(', ')
                }

                return ''
            },
            // videoDuration: (self) => {
            //     if (!self.artistVideo.duration) {
            //         return 'Calculating duration...'
            //     } else {
            //         return self.artistVideo.duration
            //     }
            // },
            // mediaCarouselStyle: (self) => {
            //     if (!self.screen.isMobile.value && !self.screen.isSmallMobile.value) {
            //         return self.regularScreenCarouselStyles
            //     } else if (self.screen.isMobile.value && !self.screen.isSmallMobile.value) {
            //         return self.mobileScreenCarouselStyles
            //     } else if (self.screen.isSmallMobile.value) {
            //         return self.xsScreenCarouselStyles
            //     }
            // },
            // regularScreenCarouselStyles: (self) => {
            //     if (self.mediaCarousel.length === 1) {
            //         return {
            //             'margin-left': '100px'
            //         }
            //     } else if (self.mediaCarousel.length === 2) {
            //         return {
            //             'margin-left': '200px'
            //         }
            //     } else {
            //         return {
            //             'margin-left': '140px'
            //         }
            //     }
            // },
            // mobileScreenCarouselStyles: (self) => {
            //     if (self.mediaCarousel.length === 1) {
            //         return {
            //             'margin-left': 'auto',
            //             'margin-right': 'auto'
            //         }
            //     } else if (self.mediaCarousel.length === 2) {
            //         return {
            //             'margin-left': '200px'
            //         }
            //     } else {
            //         return {
            //             'margin-left': 'auto',
            //             'margin-right': 'auto'
            //         }
            //     }
            // },
            // xsScreenCarouselStyles: (self) => {
            //     if (self.mediaCarousel.length === 1) {
            //         return {
            //             'margin-left': 'auto',
            //             'margin-right': 'auto'
            //         }
            //     } else if (self.mediaCarousel.length === 2) {
            //         return {
            //             'margin-left': '200px'
            //         }
            //     } else {
            //         return {
            //             'margin-left': '91px'
            //         }
            //     }
            // },
            socialLink: () => (social) => {
                switch (social.type) {
                    case 'web_site':
                        return social.link
                    case 'Instagram':
                        return social.link.includes(social.type.toLowerCase())
                            ? social.link
                            : `https://www.instagram.com/${social.link}`
                    case 'Facebook':
                        return social.link.includes(social.type.toLowerCase())
                            ? social.link
                            : `https://www.facebook.com/${social.link}`
                    case 'Tiktok':
                        return social.link.includes(social.type.toLowerCase())
                            ? social.link
                            : `https://vm.tiktok.com/${social.link}`
                    case 'Youtube':
                        return social.link.includes(social.type.toLowerCase())
                            ? social.link
                            : `https://www.youtube.com/channel/${social.link}`
                    case 'Mixcloud':
                        return social.link.includes(social.type.toLowerCase())
                            ? social.link
                            : `https://www.mixcloud.com/${social.link}`
                    case 'Spotify':
                        return social.link.includes(social.type.toLowerCase())
                            ? social.link
                            : `https://open.spotify.com/artist/${social.link}`
                    case 'Soundcloud':
                        return social.link.includes(social.type.toLowerCase())
                            ? social.link
                            : `https://www.soundcloud.com/${social.link}`
                    default:
                        return '#'
                }
            } /*,
                followingArtist: (self) =>
                    self.contacts.some((c) => c.artist_id === self.artistInfo.artist_id)
                        ? 'Following'
                        : 'Follow'*/
        },
        watch: {
            artistInfo: function (info) {
                if (Object.keys(info).length) {
                    this.load = false
                }
            },
            eventsInfo: function (events) {
                if (events.length) {
                    this.filterEvents()
                }
            },
            mediaInfo: function (medias) {
                if (medias.length) {
                    this.filterMedia()
                }
            }
        },
        setup() {
            const { showAuthModal } = useAuth()
            const { isSmallMobile, isMobile } = useCheckScreen()

            return {
                showAuthModal,
                screen: {
                    isSmallMobile,
                    isMobile
                }
            }
        },
        async created() {
            this.load = true

            await this.checkAuthorization()
            if (this.authed) {
                this.userInfo = await this.fetchUserInfo()
            }
            await this.initComponentData()
        },
        methods: {
            async initComponentData() {
                try {
                    this.load = true
                    const infoResp = await this.fetchArtistInfo()
                    this.artistInfo = infoResp.data
                    const mediaResp = await this.fetchArtistMedia()
                    this.mediaInfo = mediaResp.data
                    this.followerStats = await this.fetchFollowerStats()
                    this.fanStats = await this.fetchFanStats()
                    this.setFanStats()
                    this.setChartOptions()

                    if (this.claimed) {
                        if (this.authed) {
                            const venueContactsResp = await this.fetchVenueContacts()
                            this.contacts = venueContactsResp.data
                        }
                        this.fetchedContacts = true

                        const socialResp = await this.fetchArtistSocial()
                        this.socialInfo = this.populateSocialData(socialResp.data)

                        const musicResp = await this.fetchArtistMusic()
                        this.musicInfo = musicResp.data

                        const eventResp = await this.fetchEventsInfo()
                        this.eventsInfo = eventResp
                    }

                    if (this.artistInfo.web_site) {
                        this.$set(this.socialInfo, this.socialInfo.length, {
                            type: 'web_site',
                            link: this.formatWebsite(this.artistInfo.web_site)
                        })
                    }
                } catch (e) {
                    console.error(e)
                } finally {
                    this.load = false
                }
            },
            async checkAuthorization() {
                try {
                    const data = await api({
                        method: 'get',
                        url: this.URLS.xhr.fetch.checkAuth
                    })
                    this.authed = data.isAuthorized
                } catch {
                    this.authed = false
                }
            },
            async fetchUserInfo() {
                try {
                    this.load = true
                    const data = await api({
                        method: 'get',
                        url: this.URLS.xhr.fetch.user
                    })
                    return data.data[0]
                } finally {
                    this.load = false
                }
            },
            async fetchFanStats() {
                try {
                    this.load = true
                    const data = await api({
                        method: 'get',
                        url:
                            this.URLS.xhr.fetch.artistStats + `${this.artistInfo.id}/fan-stats`
                    })
                    return data
                } finally {
                    this.load = false
                }
            },
            async fetchFollowerStats() {
                try {
                    this.load = true
                    const data = await api({
                        method: 'get',
                        url:
                            this.URLS.xhr.fetch.artistStats +
                            `${this.artistInfo.id}/follower-stats`
                    })
                    return data
                } finally {
                    this.load = false
                }
            },
            async fetchArtistInfo() {
                if (!this.claimed) {
                    return await api({
                        method: 'get',
                        url: `${this.URLS.xhr.fetch.unclaimedArtist}/${this.id}/${this.artist}`
                    })
                }
                return await api({
                    method: 'get',
                    url: `${this.URLS.xhr.fetch.artist}/${this.artist}`
                })
            },
            async fetchArtistSocial() {
                return await api({
                    method: 'get',
                    url: `${this.URLS.xhr.fetch.social}/${this.artist}`
                })
            },
            async fetchArtistMedia() {
                if (!this.claimed) {
                    return await api({
                        method: 'get',
                        url: `${this.URLS.xhr.fetch.unclaimedArtistMedia}/${this.artist}/${this.id}?claimed=false&user=${this.id}`
                    })
                }
                return await api({
                    method: 'get',
                    url: `${this.URLS.xhr.fetch.media}/${this.artist}`
                })
            },
            async fetchArtistMusic() {
                return await api({
                    method: 'get',
                    url: `${this.URLS.xhr.fetch.music}/${this.artist}`
                })
            },
            // async fetchArtistFac() {
            //     return await api({
            //         method: 'get',
            //         url: this.URLS.xhr.fetch.facility
            //     })
            // },
            async fetchEventsInfo() {
                const newEvents = await api({
                    method: 'get',
                    url: this.URLS.xhr.fetch.newEvents
                })
                const advancedEvents = await api({
                    method: 'get',
                    url: this.URLS.xhr.fetch.advancedEvents
                })
                this.upcomingShows = advancedEvents.bids.filter(
                    (e) =>
                        !e.event_type && e.bookedArtists.some((a) => a.artist_id === this.id)
                )
                return [...newEvents.bids, ...advancedEvents.bids]
            },
            async fetchVenueContacts() {
                return await api({
                    method: 'get',
                    url: this.URLS.xhr.fetch.venueContacts
                })
            },
            updateCurrentMediaIndx(indx) {
                this.carouselOptions.index = indx
            },
            handleEditArtist() {
                this.redirectToEditArtist()
            },
            handleBookArtist() {
                if (this.authed) {
                    localStorage.setItem('artistEmail', this.artistInfo.band_email)
                    localStorage.setItem('artistName', this.artistInfo.band_name)
                    this.redirectToBookingFlow()
                } else {
                    this.showAuthModal = true
                }
            },
            async handleFollowArtist() {
                const postData = {
                    artist_id: this.artistInfo.artist_id
                }
                try {
                    this.load = true
                    const data = await api({
                        method: 'post',
                        url: this.URLS.xhr.mutate.addArtistContact,
                        data: postData
                    })
                    this.contacts.push(postData)
                    notification('success', 'Added artist to your contact list.')
                    return data
                } finally {
                    this.load = false
                }
            },
            async handleMessageArtist() {
                const userId = this.artistInfo.user_id

                try {
                    const response = await axios.get(
                        `/api/profile/mail-chat/chat/exist/${userId}`
                    )

                    if (response.data.exists) {
                        sessionStorage.setItem('recipient_id', userId)
                        window.open('/profile/mail-chat', '_blank')
                    } else {
                        await this.createChat(userId)
                    }
                } catch (error) {
                    console.error('Error checking chat:', error)
                }
            },

            async createChat(userId) {
                try {
                    const response = await axios.post('/api/profile/mail-chat', {
                        recipient_id: userId,
                        message: 'User Inquiry'
                    })

                    if (response.data.message === 'Message successfully sent') {
                        sessionStorage.setItem('recipient_id', userId)
                        window.open('/profile/mail-chat', '_blank')
                    }
                } catch (error) {
                    console.error('Error creating chat:', error)
                }
            },

            // handleReadMore() {
            //     this.showBioPartTwo = true
            // },
            // handleDateClick(day, label) {
            //     if (this.authed) {
            //         if (this.currentUser) {
            //             this.toggleDateAvail(day, label)
            //         } else {
            //             if (day.notAvail) {
            //                 return
            //             } else if (this.userInfo.bookingVenue) {
            //                 const date = this.convertLabelToDate(label, day)
            //                 const formattedDate = moment(date).format('MMM Do YYYY')
            //
            //                 localStorage.setItem('event-date-from-profile', formattedDate)
            //                 localStorage.setItem('profile-email', this.artistInfo.band_email)
            //                 localStorage.setItem('profile-name', this.artistInfo.band_name)
            //
            //                 this.redirectToBookingFlow()
            //             } else {
            //                 this.redirectToCreateVenueProfile()
            //             }
            //         }
            //     }
            // },
            // handleUpgradeClick() {
            //     window.location.href = this.URLS.redirect.marketingPlan
            // },
            // handleLoadVideo() {
            //     this.$set(
            //         this.artistVideo,
            //         'duration',
            //         this.convertToMinutes(this.$refs['video-player'].duration)
            //     )
            // },
            // handlePlayVideo() {
            //     if (!this.videoPlaying) {
            //         this.$refs['video-player'].play()
            //         this.videoPlaying = true
            //     } else {
            //         this.$refs['video-player'].pause()
            //         this.videoPlaying = false
            //     }
            // },
            hasFanStats() {
                return (
                    this.socialInfo.length && this.gender && this.ageSeries && this.topCities
                )
            },
            setFanStats() {
                this.topCities = {
                    series: [
                        this.fanStats.top_cities[0].count,
                        this.fanStats.top_cities[1].count,
                        this.fanStats.top_cities[2].count,
                        this.fanStats.top_cities[3].count,
                        100 -
                            this.fanStats.top_cities[0].count -
                            this.fanStats.top_cities[1].count -
                            this.fanStats.top_cities[2].count -
                            this.fanStats.top_cities[3].count
                    ],
                    labels: [
                        this.fanStats.top_cities[0].name,
                        this.fanStats.top_cities[1].name,
                        this.fanStats.top_cities[2].name,
                        this.fanStats.top_cities[3].name,
                        'Other cities'
                    ]
                }
                this.gender = {
                    series: [
                        this.fanStats.gender_stats.male,
                        this.fanStats.gender_stats.female
                    ],
                    labels: ['Male', 'Female']
                }
                this.ageSeries = [
                    {
                        name: 'age',
                        data: [
                            this.fanStats.age_stats['0-17'],
                            this.fanStats.age_stats['18-24'],
                            this.fanStats.age_stats['25-34'],
                            this.fanStats.age_stats['35-54'],
                            this.fanStats.age_stats['54+']
                        ]
                    }
                ]
            },
            setChartOptions() {
                this.citiesDonutChartOptions = {
                    plotOptions: {
                        pie: {
                            expandOnClick: false,
                            donut: {
                                size: '50%'
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false,
                        formatter: function (val) {
                            return val + ' %'
                        }
                    },
                    legend: {
                        show: false
                    },
                    colors: ['#CDEB09', '#BA87FF', '#646464', '#8B8B8B', '#ACACAC'],
                    labels: this.topCities.labels
                }
                this.genderDonutChartOptions = {
                    plotOptions: {
                        pie: {
                            expandOnClick: false,
                            donut: {
                                size: '50%'
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    legend: {
                        show: false
                    },
                    colors: ['#CDEB09', '#BA87FF'],
                    labels: this.gender.labels
                }
                this.ageChartOptions = {
                    chart: {
                        id: 'age-chart'
                    },
                    dataLabels: {
                        formatter: function (val) {
                            return val + ' %'
                        }
                    },
                    yaxis: {
                        show: false
                    },
                    xaxis: {
                        type: 'category',
                        categories: ['0-17', '18-24', '25-34', '35-54', '54+'],
                        labels: {
                            style: {
                                colors: ['#DEDEDE', '#DEDEDE', '#DEDEDE', '#DEDEDE', '#DEDEDE']
                            }
                        },
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false
                        }
                    },
                    grid: {
                        borderColor: 'rgba(255, 255, 255, 0.10)'
                    },
                    fill: {
                        colors: ['#CDEB09']
                    },
                    tooltip: {
                        enabled: false
                    }
                }
            },
            populateSocialData(socials) {
                return socials.map((s) => ({
                    ...s,
                    link: s.link.includes('http') ? s.link : 'https://' + s.link
                }))
            },
            // async handleAddUnavail(date) {
            //     const formattedDate = this.getFormattedDate(date)
            //
            //     const data = await api({
            //         method: 'post',
            //         url: '/api/profile/events',
            //         data: {
            //             date_from: formattedDate,
            //             date_to: formattedDate,
            //             start_date_info: formattedDate,
            //             end_date_info: formattedDate,
            //             price: 0,
            //             tour_mode: false,
            //             available: false
            //         }
            //     })
            //     return data
            // },
            // async handleRemoveUnavail(date) {
            //     let unavails = await this.getAllArtistUnavailableDates()
            //
            //     let unavailDay = unavails.find((e) => {
            //         let eventDate = new Date(e.date)
            //
            //         return (
            //             eventDate.getYear() === date.getYear() &&
            //             eventDate.getMonth() === date.getMonth() &&
            //             eventDate.getDate() === date.getDate()
            //         )
            //     })
            //
            //     if (unavailDay) {
            //         const data = await api({
            //             method: 'delete',
            //             url: '/api/profile/events/' + unavailDay.id
            //         })
            //         return data
            //     }
            // },
            // getFormattedDate(date) {
            //     let year = date.getFullYear()
            //     let month = date.getMonth() + 1
            //     let day = date.getDate()
            //
            //     return `${year}-${month}-${day}`
            // },
            // toggleDateAvail(day, label) {
            //     if (day.booked) return
            //     if (day.notAvail) {
            //         this.$set(day, 'notAvail', false)
            //         const date = this.convertLabelToDate(label, day)
            //         this.handleRemoveUnavail(date)
            //     } else {
            //         this.$set(day, 'notAvail', true)
            //         const date = this.convertLabelToDate(label, day)
            //         this.handleAddUnavail(date)
            //     }
            // },
            // convertToMinutes(seconds) {
            //     let finalSeconds = Math.floor(seconds % 60)
            //
            //     if (finalSeconds >= 0 && finalSeconds < 10) {
            //         finalSeconds = `0${finalSeconds}`
            //     }
            //     return `${(seconds / 60) | 0}:${finalSeconds}`
            // },
            filterEvents() {
                let bookedEvents = []

                for (let i = 0; i < this.eventsInfo.length; i++) {
                    let event = this.eventsInfo[i]

                    event?.artist_bid?.forEach((artist) => {
                        if (artist.artist_id === this.id && artist.status === 3) {
                            bookedEvents.push(event)
                        }
                    })
                }

                this.filteredEvents = bookedEvents
            },
            filterMedia() {
                this.artistVideos = this.mediaInfo.filter((m) => m.type === 'video')
                this.mediaCarousel = this.mediaInfo.filter((m) => m.type === 'image')
            },
            formatWebsite(url) {
                if (!url.includes('http')) {
                    return `http://${url}`
                }

                return url
            },
            formatSummedValue(num) {
                try {
                    if (num >= 1_000_000_000) {
                        return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B'
                    }
                    if (num >= 1_000_000) {
                        return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
                    }
                    if (num >= 1_000) {
                        return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'
                    }
                    if (num <= 0 || !num) {
                        return 'N/A'
                    }
                    return num.toFixed(0).toString()
                } catch {
                    return 'N/A'
                }
            },
            redirectToEditArtist() {
                window.location.href = `${this.URLS.redirect.edit[0]}/${this.artistInfo.slug}/${this.URLS.redirect.edit[1]}`
            },
            redirectToBookingFlow() {
                window.location.href = `${this.URLS.redirect.booking}/#referred-by-artist-profile`
            },
            redirectToCreateVenueUser() {
                this.showAuthModal = true
            },
            redirectToCreateVenueProfile() {
                window.location.href = `${this.URLS.redirect.createVenueProfile}`
            },
            followBtnClick() {
                if (this.authed) {
                    this.handleFollowArtist()
                } else {
                    this.showAuthModal = true
                }
            },
            messageArtist() {
                if (this.authed) {
                    this.handleMessageArtist()
                } else {
                    this.showAuthModal = true
                }
            },
            formatNumFollowers(followers) {
                if (followers < 1000) {
                    return followers
                } else if (followers < 1000000) {
                    return (followers / 1000).toFixed(1) + ' K'
                } else if (followers >= 1000000) {
                    return (followers / 1000000).toFixed(1) + ' M'
                }
            },

            calculateNumFollowers(social) {
                const followers = Number(
                    JSON.parse(this.followerStats[social.type.toLowerCase()] || '0')
                )
                return this.formatNumFollowers(followers)
            }

            // async getAllArtistUnavailableDates() {
            //     const data = await api({
            //         method: 'get',
            //         url: '/api/profile/events'
            //     })
            //     let events = data.events.data
            //
            //     events = events.filter((e) => !e.available)
            //     return events.map((e) => ({
            //         ...e,
            //         date: this.formatEventDate(e)
            //     }))
            // },
            // formatEventDate(event) {
            //     const originalEventDay = event.date.split('T')[0].split('-')
            //     const year = originalEventDay[0]
            //     const month = originalEventDay[1]
            //     const day = originalEventDay[2]
            //
            //     return `${month}-${day}-${year}`
            // }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';

    .artist-profile-container {
        padding: 35px 16px;
        .info-wrapper {
            .artist-profile-image {
                min-width: 343px;
                min-height: 343px;
                border-radius: 16px;
                background: lightgray 50% / cover no-repeat;
                @media screen and (min-width: $mobile) {
                    min-width: 514px;
                    min-height: 514px;
                }
            }
            .info-wrapper-right-col {
                color: $darker-grey;
                .artist-name {
                    @include page-headline;
                    margin-bottom: 0px;
                    margin-top: 16px;
                }
                .artist-location {
                    @include base-font-16;
                    font-weight: 400;
                    line-height: 125%;
                }
                .artist-keywords {
                    @include base-font-14;
                    font-weight: 400;
                    margin-top: 24px;
                }
                .artist-social-reach {
                    @include base-font-20;
                    margin-top: 24px;
                    line-height: 24px;
                    margin-bottom: 10px;
                }
                .artist-socials {
                    display: flex;
                    gap: 8px;
                    .social img {
                        height: 20px;
                    }
                    a {
                        text-decoration: none;
                        display: flex;
                        .followers-count {
                            color: $darker-grey;
                            @include base-font-14;
                            line-height: 20px;
                            text-decoration: none;
                            margin-left: 8px;
                        }
                    }
                }
                .artist-short-bio {
                    @include base-font-16;
                    margin-top: 24px;
                    margin-bottom: 24px;
                    font-weight: 400;
                    line-height: 24px;
                }
                .page-owner-title {
                    color: $white;
                    @include base-font-16;
                    font-weight: 600;
                    line-height: 20px;
                }
                .page-owner-container {
                    margin-top: 8px;
                    display: flex;
                    gap: 10px;
                    .page-owner-image {
                        width: 24px;
                        height: 24px;
                        border-radius: 120px;
                        border: 1px solid $lighter-dark;
                        background-size: cover;
                    }
                    .page-owner-name {
                        @include base-font;
                        font-weight: 400;
                        line-height: 24px;
                    }
                }
                .artist-actions {
                    display: flex;
                    padding: 8px 16px;
                    justify-content: space-between;
                    align-items: flex-start;
                    border-top: 1px solid $dark-2;
                    padding-bottom: 40px;
                    position: fixed;
                    bottom: 0;
                    left: 0;
                    z-index: 200;
                    background: $black-2;
                    width: 100%;
                    .artist-actions-left-container {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }
                    button {
                        display: flex;
                        padding: 8px 12px;
                        align-items: center;
                        gap: 4px;
                        border-radius: 120px;
                        border: 1px solid $lime;
                        background: $black;
                        color: $lime;
                        @include base-font-14;
                        line-height: 115%;
                        letter-spacing: 0.14px;
                        &.book-artist-btn {
                            background: $lime;
                            color: $dark;
                        }
                    }
                    @media screen and (min-width: $mobile) {
                        position: relative;
                        padding: 0;
                        border-top: none;
                        margin-top: 24px;
                        justify-content: start;
                        gap: 8px;
                        flex-direction: row-reverse;
                    }
                }
            }
            @media screen and (min-width: $mobile) {
                display: flex;
                gap: 21px;
            }
        }
        .section-title {
            color: $white;
            @include base-font-28;
            font-weight: 600;
            line-height: 32px;
            &.media {
                display: none;
                @media screen and (min-width: $mobile) {
                    display: block;
                    position: absolute;
                }
            }
        }

        .media-wrapper {
            margin-top: 84px;
            .organizer {
                width: 100%;
            }
        }

        .fan-stats-wrapper {
            margin-top: 84px;
            .section-title {
                margin-bottom: 24px;
            }
            .fan-stats-columns {
                display: flex;
                justify-content: space-between;
                .fan-stats-column {
                    color: $white;
                    @include base-font-16;
                    font-weight: 600;
                    line-height: 20px;
                    .chart-container {
                        display: flex;
                        align-items: center;
                        .legend-container {
                            min-width: 150px;
                            .legend {
                                display: flex;
                                justify-content: space-between;
                                @include base-font-16;
                                font-weight: 400;
                                .city-name {
                                    text-align: right;
                                    min-width: 100px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
